

import state from './moduleQuotesState.js'
import mutations from './moduleQuotesMutations.js'
import actions from './moduleQuotesActions.js'
import getters from './moduleQuotesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

